export {
  SITE_AUDIT_IN_PROGRESS_STATUSES as IN_PROGRESS,
  isSiteAuditInProgress,
} from "@shared/site-audit";

export function apiErrorMessage(error: unknown, fallback: string) {
  if (!(error instanceof Error)) return fallback;
  const jsonStart = error.message.indexOf("{");
  if (jsonStart === -1) return fallback;
  try {
    const body = JSON.parse(error.message.slice(jsonStart)) as { message?: unknown };
    if (typeof body.message === "string" && body.message.trim()) return body.message;
  } catch {
    return fallback;
  }
  return fallback;
}
